import _isEmpty from 'underscore/cjs/isEmpty.js'

import { contentfulFetch } from '~/services/contentful/helpers/functions'
import { isObject, strToSnakeCase } from '~/utils/helpers'

export const useMediaStore = defineStore('media', {
  state: () => {
    return {
      posts: {},

      featuredPost: {},
      postByCategory: {},
      categoryConfig: {
        in_the_news: {
          category: 'In the news',
          featured: {},
          limit: 3,
          offset: 0,
          total: 0
        },
        press_release: {
          category: 'Press release',
          featured: {},
          limit: 4,
          offset: 0,
          total: 0
        },
        research: {
          category: 'Research',
          featured: {},
          limit: 4,
          offset: 0,
          total: 0
        }
      },

      authorPosts: {
        items: []
      },

      post: {},
      latestNews: {}
    }
  },

  getters: {
    featured: state => state.featuredPost
  },

  actions: {
    async getFeatured ({ preview } = {}) {
      const res = await contentfulFetch('/api/contentful/media/get-featured', {
        method: 'POST',
        body: {
          preview
        }
      })

      const items = res?.items

      if (res?.total === 0 || _isEmpty(items)) {
        return {}
      }

      const featured = {
        ...items?.[0],
        exist: true
      }

      delete featured.layout

      this.featuredPost = featured
      this.categoryConfig[strToSnakeCase(featured?.category)].featured = featured

      return featured
    },

    async getPosts ({ limit, offset, preview } = {}) {
      const res = await contentfulFetch('/api/contentful/media/get-posts', {
        method: 'POST',
        body: {
          limit,
          offset,
          preview
        }
      })

      const items = res?.items

      if (res?.total === 0) {
        this.posts = {}
        return res
      }

      if (!offset) {
        this.posts = res

        return res
      }

      if (isObject(items)) {
        this.posts.items.push(items)
      } else {
        this.posts.items.push(...items)
      }

      return res
    },

    async getPostsByCategory ({ categories } = {}) {
      const res = await contentfulFetch('/api/contentful/media/get-posts-by-category', {
        method: 'POST',
        body: {
          categories
        }
      })

      if (!res) {
        return {}
      }

      Object.keys(res).forEach(key => {
        if (res[key]?.total === 0) {
          this.postByCategory[key] = {}
        }

        this.categoryConfig[key].total = res[key]?.total

        const offset = categories[key].offset

        if (!offset) {
          this.postByCategory[key] = res[key]
        }
      })

      return res
    },

    async getAuthorPosts ({
      author,
      authorUrl,
      preview = false,
      offset = 0,
      limit = 5,
      slug,
      slugNot,
      tags = []
    } = {}) {
      const res = await contentfulFetch('/api/contentful/media/get-author-posts', {
        method: 'POST',
        body: {
          ...removeFalseyObj({
            author,
            authorUrl: authorUrl ? `/${authorUrl}` : null,
            slug,
            slugNot,
            tags
          }),
          preview,
          offset,
          limit
        }
      })

      const items = res?.items

      if (!offset) {
        this.authorPosts.items = items
        this.authorPosts.total = res?.total
        return res
      }

      if (isObject(items)) {
        this.authorPosts.items.push(items)
      } else {
        this.authorPosts.items.push(...items)
      }

      this.authorPosts.total = res?.total

      return res
    },

    async getPost ({ slug, preview } = {}) {
      if (!slug) {
        return {}
      }

      const res = await contentfulFetch('/api/contentful/media/get-post', {
        method: 'POST',
        body: {
          limit: 5,
          slug,
          preview
        }
      })

      this.post = res?.post
      this.latestNews = res?.latestNews

      return res
    }
  }
})
